import React from 'react'
import styled from 'styled-components'

import { BotSelect } from './BotSelect'
import { GoBackButton } from './GoBackButton'
import { CreateBotIcon } from './CreateBotIcon'
import { useAccessLevel } from '../../store/user'
import { shouldShowBotActions } from './BotActionService'
import { BotDuplicateAction } from './BotDuplicateAction'
import { useLocation } from 'react-router'

export const BotActions: React.FC = () => {
  const { pathname } = useLocation()
  const accessLevel = useAccessLevel()

  if (!shouldShowBotActions(accessLevel)) {
    return null
  }

  if (pathname === '/users') {
    return <GoBackButton />
  }

  return (
    <>
      <BotSelect />
      {accessLevel.admin && (
        <NewBotActionButtons>
          <CreateBotIcon />
          <BotDuplicateAction />
        </NewBotActionButtons>
      )}
    </>
  )
}

const NewBotActionButtons = styled.div`
  margin: 15px 0 15px 0;
`
